/**
 * RevenueCat entitlement identifier.
 * Must match the entitlement ID configured in the RevenueCat dashboard.
 */
export const RC_ENTITLEMENT_ID = "Sigma Games Pro";
